/**
 * Public application form API (no auth required).
 * GET /api/apply/listing/:listingId - listing info for the form
 * POST /api/apply/submit - submit application (creates tenant, uploads docs, sends emails)
 */

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";

export async function getListingForApply(listingId) {
  const res = await fetch(
    `${API_BASE_URL}/apply/listing/${encodeURIComponent(listingId)}`
  );
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || "Failed to load listing");
  }
  return res.json();
}

export async function submitApplication(payload) {
  const res = await fetch(`${API_BASE_URL}/apply/submit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    console.error("[APPLY] submitApplication failed", {
      status: res.status,
      statusText: res.statusText,
      body: data,
      listingId: payload?.listingId,
    });
    const msg = data.details
      ? JSON.stringify(data.details)
      : data.error || "Submission failed";
    throw new Error(msg);
  }
  return data;
}
